"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Timer = /** @class */ (function (_super) {
    __extends(Timer, _super);
    function Timer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            tempShowTimer: true,
        };
        _this.count = function () {
            var now = new Date().getTime();
            var timeLeft = _this.deadline - now;
            var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
            _this.setState({ days: days, minutes: minutes, hours: hours, seconds: seconds });
            if (timeLeft < 0) {
                clearInterval(_this.x);
                _this.setState({ days: 0, minutes: 0, hours: 0, seconds: 0, tempShowTimer: false }, function () {
                    var _a;
                    if ((_a = _this.props.options) === null || _a === void 0 ? void 0 : _a.onTimerEnd) {
                        _this.props.options.onTimerEnd();
                    }
                });
            }
        };
        return _this;
    }
    Timer.prototype.componentDidMount = function () {
        var dater = this.props.date;
        this.deadline = new Date(dater).getTime();
        this.count();
        this.x = setInterval(this.count, 1000);
    };
    Timer.prototype.render = function () {
        var _a = this.state, days = _a.days, seconds = _a.seconds, hours = _a.hours, minutes = _a.minutes, tempShowTimer = _a.tempShowTimer;
        var options = this.props.options || {};
        var introTextposition = options && options.introTextposition ? options.introTextposition : "left";
        var customClassWithColor = options.customClass || "";
        if (customClassWithColor.indexOf("color-") < 0) {
            customClassWithColor +=
                (options === null || options === void 0 ? void 0 : options.onDark) === true ? " color-ui-white" : " color-ui-black";
        }
        return (React.createElement("div", { className: "inline-block", "data-testid": this.props.testId }, this.props.showTimer && tempShowTimer ? (React.createElement("div", { "data-testid": this.props.testId, className: " " + customClassWithColor },
            React.createElement("p", { className: "font-medium mar-b-xxs type-base text-" + introTextposition, "aria-describedby": "spoken-timer" }, (options === null || options === void 0 ? void 0 : options.timerIntroText) && (options === null || options === void 0 ? void 0 : options.timerIntroText.slice(0, options === null || options === void 0 ? void 0 : options.maxCharLimit))),
            React.createElement("div", { className: "flex mar-b-xs rel" },
                React.createElement("div", { className: "hidden-spoken", id: "spoken-timer" },
                    days,
                    " days ",
                    hours,
                    " hours ",
                    minutes,
                    " minutes ",
                    seconds,
                    " seconds"),
                React.createElement("div", { className: "flex flex-column text-center width-xl mar-r-xxs", "aria-hidden": true },
                    React.createElement("div", { className: "type-xl font-medium line-h-sm mar-b-xxxs" }, days),
                    React.createElement("div", { className: "type-xs" }, "DAYS")),
                React.createElement("div", { className: "flex flex-column text-center width-xl mar-r-xxs", "aria-hidden": true },
                    React.createElement("div", { className: "type-xl font-medium line-h-sm mar-b-xxxs" }, hours),
                    React.createElement("div", { className: "type-xs" }, "HRS")),
                React.createElement("div", { className: "flex flex-column text-center width-xl mar-r-xxs", "aria-hidden": true },
                    React.createElement("div", { className: "type-xl font-medium line-h-sm mar-b-xxxs" }, minutes),
                    React.createElement("div", { className: "type-xs" }, "MIN")),
                React.createElement("div", { className: "flex flex-column text-center width-xl mar-r-xxs", "aria-hidden": true },
                    React.createElement("div", { className: "type-xl font-medium line-h-sm mar-b-xxxs" }, seconds),
                    React.createElement("div", { className: "type-xs" }, "SEC"))))) : null));
    };
    return Timer;
}(React.Component));
exports.default = Timer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Timer/Timer.js
// module id = 1825
// module chunks = 8